var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7982 12.7984L17.9099 12.8189C18.02 12.8185 18.1289 12.7963 18.2304 12.7536C18.3318 12.7109 18.4238 12.6485 18.501 12.57C18.6405 12.4211 18.7155 12.2231 18.7096 12.0192C18.7023 11.8098 18.6158 11.611 18.4676 11.4629C18.3195 11.3147 18.1207 11.2282 17.9113 11.2209L12.7982 11.2018L12.8187 6.0901C12.8183 5.98002 12.7961 5.8711 12.7534 5.76964C12.7107 5.66819 12.6483 5.57619 12.5698 5.49896C12.4209 5.35945 12.2229 5.28447 12.019 5.29036C11.8115 5.30419 11.6158 5.392 11.4675 5.53785C11.3881 5.60904 11.3262 5.69754 11.2866 5.7965C11.247 5.89546 11.2307 6.00222 11.2391 6.10848L11.2016 11.2018L6.08991 11.1813C5.98016 11.1817 5.87157 11.2038 5.77038 11.2462C5.66918 11.2887 5.57736 11.3507 5.50018 11.4288C5.36068 11.5776 5.28569 11.7756 5.29158 11.9796C5.30541 12.1871 5.39322 12.3828 5.53907 12.5311C5.61194 12.6083 5.70072 12.6687 5.79925 12.7081C5.89779 12.7476 6.00372 12.7651 6.1097 12.7595L11.2016 12.7984L11.1811 17.9101C11.1782 18.0158 11.1969 18.1209 11.2362 18.2191C11.2755 18.3172 11.3345 18.4063 11.4095 18.4807L11.4286 18.4998C11.5774 18.6393 11.7755 18.7143 11.9794 18.7084C12.1867 18.699 12.3837 18.615 12.5339 18.4718C12.6842 18.3286 12.7775 18.1358 12.7968 17.9292L12.7982 12.7984Z",
    fill: "var(--icon-primary-color)",
    stroke: "var(--icon-primary-color)",
    strokeWidth: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAdd);
export default __webpack_public_path__ + "static/media/ic_add.c99be5ac9d2f8ccd1bafabb153e93235.svg";
export { ForwardRef as ReactComponent };